/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mDanmaku.vue?vue&type=template&id=0fa33b8c&scoped=true"
import script from "./mDanmaku.vue?vue&type=script&lang=js"
export * from "./mDanmaku.vue?vue&type=script&lang=js"
import style0 from "./mDanmaku.vue?vue&type=style&index=0&id=0fa33b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa33b8c",
  null
  
)

export default component.exports